import ResponsumosLogoImg from "@/assets/responsumos.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const ResponsumOSLogo = (props: Props) => (
  <LogoImage imgSrc={ResponsumosLogoImg} alt="Responsumos Logo" size="navbar" {...props} />
);
